import React from "react";
import { Tooltip } from "antd";
import {
  formatFilterKey,
  formatPlotFilterValue,
} from "@/components/UI/TableToolbar/Filtering/filtersUtil";
import {
  FILTER_BUTTON_SIZE,
  FILTER_BUTTON_PADDING,
  FILTER_BUTTON_Y_OFFSET,
} from "@/components/VivoPlots/functions/addFilterButton";
import {
  PlotSize,
  DEFAULT_PLOT_SIZE,
} from "@/components/VivoPlots/functions/addLabels";

type FilterButtonOverlayProps = {
  plotFilters?: any;

  metadata?: any;
  columnsTitleCreator?: (column: string) => string;
  onClick?: () => void;
  plotSize?: PlotSize;
};

export const FilterButtonOverlay: React.FC<FilterButtonOverlayProps> = ({
  plotFilters,
  metadata,
  columnsTitleCreator,
  onClick,
  plotSize = DEFAULT_PLOT_SIZE,
}) => {
  if (!plotFilters || Object.keys(plotFilters).length === 0) {
    return null;
  }

  const tooltipContent = (
    <div
      className="max-w-xs max-h-[200px] overflow-y-auto"
      data-testid="plot-filters-tooltip-content"
    >
      <div className="font-semibold mb-2">Plot Filters</div>
      <div className="space-y-1">
        {Object.entries(plotFilters).map(([key, value]) => (
          <div key={key} className="text-xs">
            <span className="font-medium">
              {formatFilterKey(key, columnsTitleCreator)}
            </span>
            <span className="ml-1">
              {formatPlotFilterValue(
                value as any,
                metadata?.filters?.[key]?.data_type || "text",
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  // For medium and large plots, reduce Y offset to align with controls
  const filterYOffset =
    plotSize === "medium" || plotSize === "large" ? -2 : FILTER_BUTTON_Y_OFFSET;

  return (
    <Tooltip title={tooltipContent} placement="bottomLeft">
      <div
        data-testid="plot-filters-button"
        onClick={onClick}
        role="button"
        style={{
          position: "absolute",
          left: `${FILTER_BUTTON_PADDING}px`,
          top: `${FILTER_BUTTON_PADDING + filterYOffset}px`,
          width: `${FILTER_BUTTON_SIZE}px`,
          height: `${FILTER_BUTTON_SIZE}px`,
          cursor: "pointer",
          zIndex: 10,
          backgroundColor: "transparent",
        }}
      />
    </Tooltip>
  );
};
